export default __webpack_public_path__ + "static/media/dashbaordHome.33c0f7ca.png";